export default __webpack_public_path__ + "static/media/ash.68b6109c.jpg";